import type { LabeledOption } from '@iheartjane/types';

import { overrideCustomCategoryLabels } from '@jane/search/util';
import type { Store } from '@jane/shared/types';

interface CustomSubcategoryLabelArgs {
  store: Store;
  subcategory: LabeledOption;
}
export const customSubcategoryLabel = ({
  store,
  subcategory: { label, value },
}: CustomSubcategoryLabelArgs) =>
  overrideCustomCategoryLabels(
    store?.state === 'California',
    store?.custom_product_type_labels
  )?.[value] ?? label;
